import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'ddc-definition',
  templateUrl: './ddc-definition.component.html',
  styleUrl: './ddc-definition.component.scss',
})
export class DdcDefinitionComponent implements OnInit {
  @Input('text') _text: string
  constructor() {}

  ngOnInit(): void {}
}
